/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../CSS/general.css";
import Axios from "axios";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import { AgGridReact } from 'ag-grid-react';
import { Form} from 'react-bootstrap';
import moment from "moment";
import { AppContext } from "./AppContext";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpModal from "./HelpMessagePopup";
import LoaderGif from "../../images/365 loading.gif";
function JobDetail(props) {
    const urlParams = new URLSearchParams(window.location.search);
    const [appOrg]= useContext(AppContext);
    const [gridApi, setGridApi] = useState(null);
    ////const [gridOptions, setGridOptions] = useState(null);
    const [filterChecked, setFilterChecked] = useState(["Error"])
    const [historyData, setHistoryData] = useState([])
    const rowHeight = 25;
    const headerHeight = 30;

    const getRowStyle = params => {
        return { fontSize: "Small" };
    };

    function onFirstDataRendered(params) {
        params.api.sizeColumnsToFit();
    }

    const dateFormatter = (params) => {
        if (!params.value)
            return "";
        if (!params.value || params.value === "0001-01-01T00:00:00") {
            return "";
        }
        if (params.value.includes('T')) {
            let utcDate = new Date(params.value);
            let day = String(utcDate.getDate()).padStart(2, '0');
            let month = String(utcDate.getMonth() + 1).padStart(2, '0');
            let year = utcDate.getFullYear();
            let hours = String(utcDate.getHours()).padStart(2, '0');
            let minutes = String(utcDate.getMinutes()).padStart(2, '0');
            let seconds = String(utcDate.getSeconds()).padStart(2, '0');
            return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
            ////var dateString = params.value.split('T');
            ////if (dateString.length > 0) {
            ////    var timeString = dateString[1];
            ////    var parseTime = timeString.substring(0, 8);
            ////    return `${parseDate(dateString[0])} ${parseTime}`;
            ////}
        }else
        return params.Value
    };


    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
    }), []);

    const onGridReady2 = (params) => {
        params.api.setGridOption("loading", true);

        ////setGridOptions(params);
        setGridApi(params.api);
        loadData(params.api);
        
        params.api.sizeColumnsToFit();
        params.api.setGridOption("loading", false);
        //console.log(appOrg);
    }

    
    const defaultFilterChecked = ["Success", "Error", "Warning"];
    const onFilterChanged = (e) => {
        const checkboxValue = e.target.value;
        const isChecked = e.target.checked;

        let updatedFilterChecked;
       
        if (checkboxValue === "All") {
            if (isChecked) {
                updatedFilterChecked = ["Success", "Error", "Warning", "All"];
            } else {
                updatedFilterChecked = [];
            }
        } else {
            if (isChecked) {
                updatedFilterChecked = [...filterChecked, checkboxValue];
            } else {
                updatedFilterChecked = filterChecked.filter(item => item !== checkboxValue);
            }
            const allChecked = ["Error", "Success", "Warning"].every(value => updatedFilterChecked.includes(value));
            if (allChecked) {
                updatedFilterChecked = ["Success", "Error", "Warning", "All"];
            } else {
                updatedFilterChecked = updatedFilterChecked.filter(item => item !== "All");
            }
        }

        setFilterChecked(updatedFilterChecked);
        var filteredData=[]
        if (props.activeTab !== "365") {
            filteredData = historyData.filter(row => {
                return updatedFilterChecked.some(keyword => row.message.includes(keyword));
            });
        }
        else {
            filteredData = historyData.filter(row => {
                return (
                    updatedFilterChecked.some(keyword => row.type.includes(keyword)) ||
                    !defaultFilterChecked.some(defaultType => row.type.includes(defaultType))
                );
            });
        }
       
        
        gridApi.setGridOption('rowData', filteredData);
    }


    async function loadData(api) {
        if (props.jobLogUrl === "") {
            api.setGridOption('rowData', []);
            return;
        }
       
        if (props.jobLogUrl === "Entra") {
            if (!api)
                return;

            api.setGridOption('rowData', []);
            api.setGridOption("loading", true);
            const config = {
                headers: {
                    Authorisation: `Bearer ` + props.token,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            const data = await Axios.get(API_ROUTE + Routes.GET_ENTRA_BACKUP_SESSION_LOGS(orgId,appOrg.tenantId ,appOrg.azureJobSession), config)
                .then((response) => {
                    if (response !== null)
                        return JSON.parse(response.data);
                })
                .catch((reason) => {
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });

            if (data) {
                var rowData = [];
                for (var i = 0; i < data.length; i++) {
                    var row = {
                        creationTime: data[i].startTime,
                        endTime: data[i].endTime,
                        message:"["+ data[i].status+"] "+ data[i].description,
                      
                    }
                    rowData.push(row);
                }  
                api.setGridOption('rowData', rowData.filter(detail => filterChecked.some(filter => detail.message.includes(filter))));

                setHistoryData(rowData)

                api.setGridOption("loading", false);
             
            }
        }
        else {
            if (!api)
                return;
            const config = {
                headers: {
                    Authorisation: `Bearer ` + props.token,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const data = await Axios.get(API_ROUTE + Routes.JOB_DETAIL(appOrg.orgId, props.jobLogUrl), config)
                .then((response) => {
                    return JSON.parse(response.data);
                })
                .catch((reason) => {
                    console.log("load Data catch" + reason.response.data);
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";                    }
                });
            if (data) {
                for (let item of data) {
                    const type = item.type;
                    if (type !== null && type !== undefined) {
                        item.message = `[${type}] ${item.message} `;
                    }
                }
                //api.setRowData(data.filter(detail => detail.title.includes("[Error]")));
                api.setGridOption('rowData', data.filter(detail => filterChecked.some(filter => detail.type.includes(filter)) ||
                    !defaultFilterChecked.some(defaultType => detail.type.includes(defaultType))));
                //setFilterChecked(['Error'])
                setHistoryData(data)
                api.setGridOption("loading", false);
                //api.setQuickFilter("Error");
                if (api?.getDisplayedRowCount() === 0)
                    api.setGridOption('activeOverlay', 'agNoRowsOverlay');
                else
                    api.setGridOption("loading", false);
            }
        }
        //api.setGridOption("loading", false);
    }

    const columnDefs = [

        {
            field: 'creationTime', headerName: 'Creation Time', valueFormatter: dateFormatter, filter: true, maxWidth: 160, minWidth: 160, flex: 1,
            getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'DD/MM/YYYY HH:mm:ss').diff(moment(date2, 'DD/MM/YYYY HH:mm:ss'));
            }
        },
        {
            field: 'endTime', headerName: 'End Time', valueFormatter: dateFormatter, maxWidth: 160, minWidth: 160, flex: 1,
            getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'DD/MM/YYYY HH:mm:ss').diff(moment(date2, 'DD/MM/YYYY HH:mm:ss'));
            }
        },
        { field: 'message', headerName: 'Description', wrapText: true, filter: true, autoHeight: true, minWidth: 400, flex: 1 },
    ];



    useEffect(() => {
        //console.lo
        if (gridApi) {
            gridApi.setGridOption("loading", true);
            gridApi.setGridOption('rowData', []);
            loadData(gridApi);
            //setLogType("Error");
            gridApi.setGridOption("loading", false);

        }
    }, [props.jobLogUrl, appOrg.azureJobSession]);

    /*   useEffect(() => {
           if(gridApi)
               gridApi.setQuickFilter(logType);
           if (gridApi?.getDisplayedRowCount() === 0)
               gridApi.setGridOption('activeOverlay', 'agNoRowsOverlay');
       }, [logType]);*/

    //useEffect(() => {
    //    if (gridApi) {
    //        loadData(gridApi);
    //    }
    //}, [props.refresh]);

    return (

        <div className="card mt-1" id="jobdetail">
            
            <div className="card-header  p-1">
                <div className="row align-items-center">
                    <div className="col-5">
                        <span className="SectionTitle ms-2" style={{ fontWeight: '500', width: '50%' }}> Job Detail
                            <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-jobdetail">Click job history above</Tooltip>}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="ms-2 bi bi-info-circle" viewBox="0 0 16 16" style={{position:'absolute'} }>
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                </svg>
                            </OverlayTrigger>
                        </span>
                    </div>

                    <div className="col d-flex justify-content-between align-items-center">
                        <Form.Group controlId="ContentPlaceHolder1_RadioButtonJobDetailFilter" className="d-flex">
                            <Form.Check id="ContentPlaceHolder1_RadioButtonJobDetailFilter_3" disabled={historyData.length === 0} label="Error" name="JobDetailRadioButton" value="Error" checked={filterChecked.includes("Error")} onChange={onFilterChanged} />
                            <Form.Check id="ContentPlaceHolder1_RadioButtonJobDetailFilter_1" disabled={historyData.length === 0} label="Warning" name="JobDetailRadioButton" value="Warning" checked={filterChecked.includes("Warning")} onChange={onFilterChanged} />
                            <Form.Check id="ContentPlaceHolder1_RadioButtonJobDetailFilter_2" disabled={historyData.length === 0} label="Success" name="JobDetailRadioButton" value="Success" checked={filterChecked.includes("Success")} onChange={onFilterChanged} />
                            <Form.Check id="ContentPlaceHolder1_RadioButtonJobDetailFilter_0" disabled={historyData.length === 0} label="All" name="JobDetailRadioButton" value="All" checked={filterChecked.includes("All")} onChange={onFilterChanged} />

                        </Form.Group>
                        <span>
                            {props.activeTab !== "365" &&
                                <button className="a-icon" id="Aad_RefreshButton" onClick={() => loadData(gridApi)} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 512 512" className="mb-1 me-2">
                                    <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z">
                                    </path>
                                </svg>
                            </button>
                            }
                            <button className="a-icon" id="ContentPlaceHolder1_btnDownload" title="Download" onClick={() => {
                            if (gridApi) {
                                gridApi.exportDataAsCsv();

                            }
                        }}>
                                    <svg xmlns="http://www.w3.org/2000/svg"  width="20" height="20" viewBox="0 0 512 512" className="mb-1 me-2">
                                        <path fill="currentColor" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z">
                                        </path>
                                </svg> </button>
                            <button id="ContentPlaceHolder1_btnClear" title="Clear Filter" style={{ color: "#007bff", cursor: 'pointer', height: "25", width: "25" }} className="me-1 mainpage_clear a-icon" onClick={(e) => {
                                if (gridApi) {
                                    gridApi.setFilterModel(null);
                                }
                            }}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="23" viewBox="0 0 32 32" width="23" style={{ cursor: 'pointer' }}>
                                    <path strokeWidth="1.5" d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"></path>
                                    <path strokeWidth="1.5" d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"></path>
                                </svg>
                            </button>
                            {!props.isAzureGuardianOnly && props.activeTab === "365" && <HelpModal about="Introduction.html" />}
                        </span>
                    </div>
                </div>
            </div>
            
            <div className="card-body p-0">
                <div id="ContentPlaceHolder1_UpdatePanel">
                    <div id="ContentPlaceHolder1_LogViewPanel" style={{  width: "100%",height:'263px' }}>
                        {(props.jobLogUrl.length > 0) ?
                            (
                                <div className="ag-theme-alpine p-1 pt-0" style={{ width: "100%", height: "263px", borderCollapse: "collapse" }} >                                    
                                    <div style={{ width: "100%", height: "257px"}}>
                                        <AgGridReact style={{ width: "100%" }}
                                            getRowStyle={getRowStyle}
                                            onGridReady={onGridReady2}
                                            defaultColDef={defaultColDef}
                                            onFirstDataRendered={onFirstDataRendered}
                                            rowHeight={rowHeight}
                                            rowBuffer={500} 
                                            pagination={true}
                                            paginationPageSize={50}
                                            paginationPageSizeSelector={[10,20, 50]}
                                            headerHeight={headerHeight}
                                            enableCellTextSelection="true"
                                            ensureDomOrder="true"
                                            overlayLoadingTemplate={
                                                `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`
                                            }
                                            overlayNoRowsTemplate={
                                                '<span className="ag-overlay-loading-center">No error records to show</span>'
                                            }
                                            suppressScrollOnNewData={true}
                                            columnDefs={columnDefs} >
                                        </AgGridReact>

                                    </div>

                                </div>

                            )
                            :
                            <div></div>}
                    </div>
                </div>
            </div>
        </div>


    );
}

export default JobDetail;